<div class="rating-name-wrapper">
    @if (showName()) {
        <label class="m-8">{{name()}}</label>
    }
    <mat-chip color="accent" [class.compact]="compact()" [class]="ratingClass()">{{text()}}</mat-chip>
</div>
